import { render, staticRenderFns } from "./ConfigureRulesModal.vue?vue&type=template&id=59ed949a&scoped=true"
import script from "./ConfigureRulesModal.vue?vue&type=script&lang=js"
export * from "./ConfigureRulesModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRulesModal.vue?vue&type=style&index=0&id=59ed949a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed949a",
  null
  
)

export default component.exports